function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", {
  id: "icon-arrow-forward_svg__icon-arrowForward-title"
}, "Pfeil: Jetzt mehr erfahren");

var _ref2 = /*#__PURE__*/React.createElement("desc", {
  id: "icon-arrow-forward_svg__icon-arrowForward-desc"
}, "Pfeil: Jetzt mehr erfahren");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 13h11.86l-3.63 4.36a1 1 0 001.54 1.28l5-6a1.19 1.19 0 00.09-.15c0-.05.05-.08.07-.13A1 1 0 0020 12a1 1 0 00-.07-.36c0-.05-.05-.08-.07-.13a1.19 1.19 0 00-.09-.15l-5-6A1 1 0 0014 5a1 1 0 00-.64.23 1 1 0 00-.13 1.41L16.86 11H5a1 1 0 000 2z",
  "data-name": "arrow-forward"
}));

function SvgIconArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    "aria-labelledby": "icon-arrowForward-title icon-arrowForward-desc"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgcm9sZT0iaW1nIiBhcmlhLWxhYmVsbGVkYnk9Imljb24tYXJyb3dGb3J3YXJkLXRpdGxlIGljb24tYXJyb3dGb3J3YXJkLWRlc2MiPgo8dGl0bGUgaWQ9Imljb24tYXJyb3dGb3J3YXJkLXRpdGxlIj5QZmVpbDogIEpldHp0IG1laHIgZXJmYWhyZW48L3RpdGxlPgo8ZGVzYyBpZD0iaWNvbi1hcnJvd0ZvcndhcmQtZGVzYyI+UGZlaWw6ICBKZXR6dCBtZWhyIGVyZmFocmVuPC9kZXNjPgo8ZyBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGRhdGEtbmFtZT0iYXJyb3ctZm9yd2FyZCI+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB0cmFuc2Zvcm09InJvdGF0ZSgtOTAgMTIgMTIpIiBvcGFjaXR5PSIwIi8+PHBhdGggZD0iTTUgMTNoMTEuODZsLTMuNjMgNC4zNmExIDEgMCAwIDAgMS41NCAxLjI4bDUtNmExLjE5IDEuMTkgMCAwIDAgLjA5LS4xNWMwLS4wNS4wNS0uMDguMDctLjEzQTEgMSAwIDAgMCAyMCAxMmExIDEgMCAwIDAtLjA3LS4zNmMwLS4wNS0uMDUtLjA4LS4wNy0uMTNhMS4xOSAxLjE5IDAgMCAwLS4wOS0uMTVsLTUtNkExIDEgMCAwIDAgMTQgNWExIDEgMCAwIDAtLjY0LjIzIDEgMSAwIDAgMC0uMTMgMS40MUwxNi44NiAxMUg1YTEgMSAwIDAgMCAwIDJ6Ii8+PC9nPjwvZz48L3N2Zz4K";
export { SvgIconArrowForward as ReactComponent };